module.exports = __webpack_public_path__ + "img/blank_map.2a1c225f.png";